import { z } from 'zod';
import { NOTE_MAX_LENGTH, STROKE_MAX_POINTS } from '../constants.js';
export const strokeSchema = z.object({
    /** Flache Punktliste [x0,y0,x1,y1,...], normalisiert auf 0..1. */
    points: z
        .array(z.number().min(0).max(1))
        .min(4)
        .max(STROKE_MAX_POINTS * 2)
        .refine((p) => p.length % 2 === 0, 'Punktliste muss gerade Länge haben'),
    color: z.string().regex(/^#[0-9a-fA-F]{6}$/),
    width: z.number().min(0.001).max(0.05),
});
export const noteColorSchema = z.enum(['yellow', 'coral', 'teal', 'lavender']);
export const noteCreateSchema = z.object({
    objectId: z.string().min(1).max(64),
    body: z.string().max(NOTE_MAX_LENGTH),
    color: noteColorSchema,
    x: z.number().min(0).max(1),
    y: z.number().min(0).max(1),
});
export const noteUpdateSchema = z.object({
    id: z.string().uuid(),
    body: z.string().max(NOTE_MAX_LENGTH).optional(),
    color: noteColorSchema.optional(),
    x: z.number().min(0).max(1).optional(),
    y: z.number().min(0).max(1).optional(),
});
//# sourceMappingURL=objectSchema.js.map